<template>
  <ai-tooltip location="bottom" content-class="ai-locked__tooltip" :top="true">
    <template v-slot:top>
      <div class="ai-locked" :style="props.style">
        <inline-svg :src="require('@/assets/icons/locked.svg')" />
      </div>
    </template>
    <template #content>
      <div class="ai-locked__content">
        <div class="ai-locked__text">
          {{ $t('common.locked-text') }}
        </div>
        <router-link :to="{ name: 'Subscriptions' }" class="ai-locked__button">
          <div class="ai-locked__button__text">
            {{ $t('common.locked-button') }}
          </div>
        </router-link>
      </div>
    </template>
  </ai-tooltip>
</template>

<script setup lang="ts">
import AiTooltip from '@/components/UI/AiTooltip/AiTooltip.vue';
import { PropType } from 'vue';

const props = defineProps({
  style: {
    type: Object as PropType<any>,
    required: false,
    default: () => ({}),
  },
});
</script>

<style scoped lang="scss" src="./AiLocked.scss" />
